import React, { useEffect, useRef, useState } from "react";

import styled from "styled-components";

import FormInput from "components/atoms/input/FormInput";
import useLoading from "components/atoms/loading/useLoading";

import AbstractModal from "components/page/modal/AbstractModal";

import { usePaymentCouponRegister } from "hooks/queries/usePayment";

import { genericEnterKeyDown } from "utils/validation";

const Container = styled.div`
    width: 100%;
`;

function CouponRegisterModal(props) {
    const { exitModal } = props;

    const { setLoading } = useLoading();

    const inputRef = useRef(null);
    const couponRegister = usePaymentCouponRegister();
    const [couponCode, setCouponCode] = useState("");

    const handleApply = () => {
        setLoading(true);
        couponRegister.mutate(
            { number: couponCode },
            {
                onSuccess: () => {
                    setCouponCode("");
                    exitModal();
                    setLoading(false);
                },
                onError: (error) => {
                    setLoading(false);
                },
            },
        );
    };

    useEffect(() => {
        if (inputRef.current) {
            inputRef.current.focus();
        }
    }, []);

    return (
        <AbstractModal
            modalTitle="쿠폰 등록"
            width={480}
            exitModal={props.exitModal}
            footer={{
                leftBtnText: "취소",
                rightBtnText: "등록",
                leftOnClick: props.exitModal,
                rightOnClick: handleApply,
            }}
        >
            <Container>
                <FormInput
                    labelDp="none"
                    placeholder="쿠폰 코드를 입력하세요"
                    value={couponCode}
                    onChange={(e) => setCouponCode(e.target.value)}
                    onKeyDown={(e) => {
                        genericEnterKeyDown(e, () => {
                            handleApply();
                        });
                    }}
                    ref={inputRef}
                />
            </Container>
        </AbstractModal>
    );
}

export default CouponRegisterModal;
